const { isEmpty, } = require('lodash');

const { optionLabel, } = require('../lib/consolidationAccountItems');
const { inheritTypes, } = require('./individualAdjustmentJournal');

const { entries } = Object;

const amountSources = {
  fixed: { label: '固定金額', },
  trialBalance: { label: '試算表残高', },
};

const accountItemOptionLabel = (accountItem) => {
  return accountItem.name + (_ => _ ? ` [${_}]` : '')(accountItem.shortcut_num);
};

const fields = ({ consolidationAccountItems = [], accountItems = [], }) => {
  return {
    name: {
      label: '名称',
      type: 'string',
      validations: {
        required: v => !isEmpty(v),
      },
    },
    inheritType: {
      label: '翌期への引き継ぎ',
      type: 'select',
      options: entries(inheritTypes).map(([k, v]) => ({ label: v.label, value: k })),
      initialValue: 'none',
      validations: {
        required: v => v != null,
      },
    },
    amountSource: {
      label: '金額の指定方法',
      type: 'select',
      options: entries(amountSources).map(([k, v]) => ({ label: v.label, value: k })),
      initialValue: 'fixed',
      hint: '試算表残高を選ぶと、実行時に指定した科目の当月残高を金額に使用します（科目振替の自動化）',
      validations: {
        required: v => v != null,
      },
    },
    amountReferenceItemId: {
      label: '金額参照科目',
      type: 'select',
      options: accountItems.map(_ => ({ label: accountItemOptionLabel(_), value: _.id })),
      hidden: _ => _.amountSource !== 'trialBalance',
      hint: '実行時にこの個別科目の試算表残高を借方・貸方の金額に使用します',
      validations: {
        requiredInSomeCase: (v, s) => !(s.amountSource === 'trialBalance' && isEmpty(v)),
      },
    },
    description: {
      label: '説明',
      type: 'text',
    },
  };
};

const itemFields = ({ consolidationAccountItems = [], sections = [], customChangeFields = [], ordersByModelType = {}, keptChangeTypes = [], }) => {
  const { buildChangeTypeOptions, } = require('../changeTypes');
  const changeTypeOptions = buildChangeTypeOptions(customChangeFields, ordersByModelType, keptChangeTypes);
  return {
    debitItemId: {
      label: '借方科目',
      type: 'select',
      options: consolidationAccountItems.map(_ => ({ label: optionLabel(_), value: _.id })),
    },
    debitSectionId: {
      label: '借方部門',
      type: 'select',
      options: sections.map(_ => ({ label: _.name, value: _.id })),
    },
    debitAmount: {
      label: '借方金額',
      type: 'float',
      initialValue: 0,
    },
    debitChangeType: {
      label: '借方増減種別',
      type: 'select',
      options: changeTypeOptions,
    },
    creditItemId: {
      label: '貸方科目',
      type: 'select',
      options: consolidationAccountItems.map(_ => ({ label: optionLabel(_), value: _.id })),
    },
    creditSectionId: {
      label: '貸方部門',
      type: 'select',
      options: sections.map(_ => ({ label: _.name, value: _.id })),
    },
    creditAmount: {
      label: '貸方金額',
      type: 'float',
      initialValue: 0,
    },
    creditChangeType: {
      label: '貸方増減種別',
      type: 'select',
      options: changeTypeOptions,
    },
  };
};

exports.fields = fields;
exports.itemFields = itemFields;
exports.amountSources = amountSources;
